export enum Page {
    INITIAL = '',
    SHOPPINGBAG= 'shoppingBag',
    CHECKOUTSHIPPING='checkoutShipping',
    CHECKOUTPAYMENT='checkoutPayment',
    ORDERCONFIRMATION='orderConfirmation',
    MYACCOUNT = 'MyAccount',
    MYORDERS= 'OrderHistory',
    ORDERDETAILS= 'OrderDetails',
    ACTIVATION='activation',
    GDPR='gdpr'
}